<template>
  <div>
    <Head title="Create Contact" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/ebupot-pph-21-tidak-final">Bukti Potong</Link>
      <span class="text-indigo-400 font-medium">/</span> Import
    </h1>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <file-input
            v-model="form.file"
            :error="form.errors.file"
            class="pb-8 pr-6 w-full lg:w-1/2"
            type="file"
            accept="csv/*"
            label="File CSV"
          />
        </div>
        <progress v-if="form.progress" :value="form.progress.percentage" max="100">
          {{ form.progress.percentage }}%
        </progress>
        <div
          class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100"
        >
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            Import Bukti Potong
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import { Head, Link, useForm } from "@inertiajs/inertia-vue3";
import FileInput from "@/Shared/FileInput";
import LoadingButton from "@/Shared/LoadingButton";

defineProps({
  organizations: Array,
});

let form = useForm({
  file: null,
});

function store() {
  form.post("/import/ebupot-pph-21-tidak-final");
}
</script>
